// extracted by mini-css-extract-plugin
export default {"baseLayerSelect":"SimpleEntityMap_baseLayerSelect__Tr-SH","mapBorder":"SimpleEntityMap_mapBorder__WE6-U"};